import React, { useState } from 'react';
import './AddSiteModal.css'; // Reuse same styles

function EditSiteModal({ site, onSave, onClose }) {
  const [name, setName] = useState(site.name);
  const [url, setUrl] = useState(site.url);
  const [iconOption, setIconOption] = useState(
    site.icon === 'placeholder' ? 'placeholder' : 
    site.icon && site.icon.startsWith('data:') ? 'upload' : 'url'
  );
  const [iconUrl, setIconUrl] = useState(
    site.icon && site.icon !== 'placeholder' && !site.icon.startsWith('data:') ? site.icon : ''
  );
  const [iconPreview, setIconPreview] = useState(
    site.icon && site.icon.startsWith('data:') ? site.icon : null
  );
  const [iconData, setIconData] = useState(
    site.icon && site.icon.startsWith('data:') ? site.icon : null
  );

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setIconPreview(reader.result);
        setIconData(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    let icon = 'placeholder';
    if (iconOption === 'upload' && iconData) {
      icon = iconData;
    } else if (iconOption === 'url' && iconUrl) {
      icon = iconUrl;
    }
    
    onSave({
      ...site,
      name,
      url,
      icon: icon
    });
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Edit Site</h2>
          <button className="close-button" onClick={onClose}>×</button>
        </div>
        
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="edit-site-name">Site Name</label>
            <input
              type="text"
              id="edit-site-name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="e.g., Gmail"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="edit-site-url">Site URL</label>
            <input
              type="url"
              id="edit-site-url"
              value={url}
              onChange={(e) => setUrl(e.target.value)}
              placeholder="e.g., https://mail.google.com"
              required
            />
          </div>

          <div className="form-group">
            <label>Site Icon</label>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', marginBottom: '10px', alignItems: 'flex-start' }}>
              <label style={{ display: 'inline-flex', alignItems: 'center', gap: '10px', cursor: 'pointer', whiteSpace: 'nowrap' }}>
                <input
                  type="radio"
                  name="edit-icon-type"
                  value="placeholder"
                  checked={iconOption === 'placeholder'}
                  onChange={(e) => setIconOption(e.target.value)}
                />
                Use placeholder (first letter)
              </label>
              <label style={{ display: 'inline-flex', alignItems: 'center', gap: '10px', cursor: 'pointer', whiteSpace: 'nowrap' }}>
                <input
                  type="radio"
                  name="edit-icon-type"
                  value="url"
                  checked={iconOption === 'url'}
                  onChange={(e) => setIconOption(e.target.value)}
                />
                Image URL
              </label>
              <label style={{ display: 'inline-flex', alignItems: 'center', gap: '10px', cursor: 'pointer', whiteSpace: 'nowrap' }}>
                <input
                  type="radio"
                  name="edit-icon-type"
                  value="upload"
                  checked={iconOption === 'upload'}
                  onChange={(e) => setIconOption(e.target.value)}
                />
                Upload image file
              </label>
            </div>
            
            {iconOption === 'url' && (
              <input
                type="url"
                id="edit-icon-url"
                value={iconUrl}
                onChange={(e) => setIconUrl(e.target.value)}
                placeholder="e.g., https://example.com/logo.png"
              />
            )}
            
            {iconOption === 'upload' && (
              <>
                <input
                  type="file"
                  id="edit-site-icon"
                  accept="image/*"
                  onChange={handleImageUpload}
                  className="file-input"
                />
                {iconPreview && (
                  <div className="image-preview">
                    <img src={iconPreview} alt="Icon preview" />
                  </div>
                )}
              </>
            )}
          </div>

          <div className="modal-actions">
            <button type="button" onClick={onClose} className="cancel-button">
              Cancel
            </button>
            <button type="submit" className="submit-button">
              Save Changes
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default EditSiteModal;
